import React from "react";
import Header from "./Component/Header"
import MemeGenerator from "./Component/MemeGenerator"
function App(){
  return(
    <div>
      <Header />
      <MemeGenerator />
    </div>
  )
}

export default App;